import React, { FC, Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import IconButton from '@material-ui/core/IconButton'
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import { createMuiTheme } from '@material-ui/core/styles'
import { styled as materialStyle } from '@material-ui/styles'
import { IValuesProps } from 'src/features/workspace-member/interface/table-interface'
import { BootstrapTooltip } from 'src/ui/atoms/bootstrap-tooltip'
import { WorkspaceRoles } from '../../../constants'

const EllipsisText = styled.div`
  display: block;
  width: fit-content;
  max-width: 2000px
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const NoDataTD = styled.div`
  width: 100%;
  text-align: center;
`

const useStyles = makeStyles(theme => ({
  cell: {
    padding: '9.5px 16px 9.5px 16px'
  }
}))

const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  }
})

const DeleteButton = materialStyle(IconButton)(() => ({
  textAlign: 'right',
  [theme.breakpoints.down('md')]: {
    marginLeft: 'auto'
  }
}))

interface IListViewBodyProps {
  data: IValuesProps[]
  tableKey: string[]
  pageSize: number
  currentPage: number
  order: 'asc' | 'desc'
  orderBy: string
  setIsOpenEditWorkspaceMemberModal: Dispatch<SetStateAction<boolean>>
  setIsOpenDeleteModal: Dispatch<SetStateAction<boolean>>
  setSelectedWorkspaceMember?: Dispatch<SetStateAction<object>>
}

const descendingComparator = (a, b, orderBy, orderValue, valueType) => {
  let result = 0;

  // To sort null value to last
  if (a[orderBy] === null) {
    return 1;
  }
  else if (b[orderBy] === null) {
    return -1;
  }

  switch(valueType) {
    case 'string':
      result = String(b[orderBy]).toLocaleLowerCase() > String(a[orderBy]).toLocaleLowerCase() ? 1 : -1
      break
    default:
      result = b[orderBy] > a[orderBy] ? 1 : -1
  }

  return result * orderValue;
}

export const ListViewBody: FC<IListViewBodyProps> = ({
  data,
  tableKey,
  pageSize,
  currentPage,
  order,
  orderBy,
  setIsOpenDeleteModal,
  setIsOpenEditWorkspaceMemberModal,
  setSelectedWorkspaceMember
}) => {
  const classes = useStyles()
  const getComparator = (order, orderBy, valueType) => {
    return (a, b) => descendingComparator(a, b, orderBy, order === 'desc' ? 1 : -1, valueType)
  }

  const stableSort = (array, order, orderBy, currentPage, pageSize) => {
    const stabilizedThis = array.map((el, index) => [el, index])
    const valueType = typeof stabilizedThis[0][0][orderBy];
    const comparator = getComparator(order, orderBy, valueType)
    return stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0])
      if (order !== 0) return order
      return a[1] - b[1]
    }).map(el => el[0])
    .slice((currentPage - 1) * pageSize, currentPage * pageSize)
  }

  return (
    <TableBody>
      {stableSort(data, order, orderBy, currentPage, pageSize)
        .map(item => {
         const { role } = item
          return (
            <TableRow key={`${item.name}${item.role}`}>
              {tableKey.map((key, idx) => {
                const columnItem = item[key]
                return (
                  <TableCell className={classes.cell} key={`${item[key]}_${idx}`}>
                    <BootstrapTooltip
                      title={columnItem}
                    >
                      <EllipsisText>
                        {item[key] !== undefined ? columnItem : (<NoDataTD>N/A</NoDataTD>)}
                      </EllipsisText>
                    </BootstrapTooltip>
                  </TableCell>
                )
              })
              }
              <TableCell className={classes.cell}>
                <DeleteButton
                  disabled={role === WorkspaceRoles.OWNER}
                  data-test='edit workspace member'
                  onClick={() => {
                    setIsOpenEditWorkspaceMemberModal(true)
                    setSelectedWorkspaceMember(item.rawData)
                  }}
                >
                  <EditTwoToneIcon/>
                </DeleteButton>
              </TableCell>
              <TableCell className={classes.cell}>
              <DeleteButton
                disabled={role === WorkspaceRoles.OWNER}
                data-test='delete workspace member'
                onClick={() => {
                  setIsOpenDeleteModal(true)
                  setSelectedWorkspaceMember(item.rawData)
                }}
              >
                <DeleteOutlineTwoToneIcon />
              </DeleteButton>
              </TableCell>
            </TableRow>
          )
        })}
    </TableBody>
  )
}
